import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-app-trl-bar-chart',
    templateUrl: './app-trl-bar-chart.component.html',
    styleUrls: ['./app-trl-bar-chart.component.scss']
})
export class AppTrlBarChartComponent implements OnInit {

    private _appForTrl: any;
    get appForTrl() {
        return this._appForTrl;
    }

    @Input() set appForTrl(val: any) {
        this._appForTrl = val;
        if (val) {
            this.chartAppForTrl = {
                series: [
                    {
                        name: "Application per TRL",
                        data: this._appForTrl.series
                    },
                ],
                chart: {
                    type: "bar",
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    width: '100%',
                    height: '100%',
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: false
                    }
                },
                colors : ['rgb(120, 182, 229)'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: "bottom",
                                offsetX: -10,
                                offsetY: 0
                            }
                        }
                    }
                ],
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                },
                xaxis: {
                    type: "category",
                    categories: this._appForTrl.labels
                },
                dataLabels: {
                    enabled: true,
                    // formatter: function(val) {
                    //     return val + "%";
                    // },
                    // offsetY: -20,
                    style: {
                        fontSize: "14px",
                        // colors: ["#304758"]
                    }
                },
                legend: {
                    position: "right",
                    // offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };

        }
    }

    chartAppForTrl: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {

    }

}
